var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[(!_vm.requiredRouteMetaAvailable)?_c('v-skeleton-loader'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }